<!--
  La línea que separa grupos de opciones dentro de un menú.
-->
<div class="menu-sep" aria-hidden="true"></div>
